'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { formatPrice } from '@/lib/utils'
import { X } from 'lucide-react'
import { ConfirmProductItem } from './campaign-register-confirm'

interface CampaignSelectedProductsStripProps {
  title: string
  countLabel: string
  items: readonly ConfirmProductItem[]
  onRemove: (item: ConfirmProductItem) => void
  removeAriaLabel?: string
}

// Dải sản phẩm đã chọn ở màn chọn sản phẩm - card gọn (không ảnh), dùng
// Carousel chung của dự án thay vì tự chế overflow-x-auto, để không đẩy
// giãn layout khi chọn nhiều tổ hợp.
export const CampaignSelectedProductsStrip = ({
  title,
  countLabel,
  items,
  onRemove,
  removeAriaLabel,
}: CampaignSelectedProductsStripProps) => {
  return (
    <div className='overflow-hidden rounded-lg bg-neutral-50'>
      <div className='flex h-14 items-center justify-between gap-2 bg-primary-500 px-5'>
        <p className='font-criteria text-sm font-bold text-white md:text-base'>
          {title}
        </p>
        <span className='shrink-0 rounded-full bg-white px-3 py-1 text-[10px] font-bold uppercase text-primary-500 md:text-xs'>
          {countLabel}
        </span>
      </div>

      <Carousel
        opts={{
          align: 'start',
          slidesToScroll: 1,
          skipSnaps: false,
        }}
        className='p-3'
      >
        <CarouselContent className='-ml-3'>
          {items.map((item, idx) => (
            <CarouselItem
              key={
                item.rowId ??
                `${item.productId}-${item.color}-${item.size}-${idx}`
              }
              className='basis-[83%] pl-3 sm:basis-[220px] md:basis-[31.25%] 2xl:basis-[23.81%]'
            >
              <div className='flex h-full flex-col justify-between gap-2 rounded-lg bg-white p-3'>
                <div className='flex items-start justify-between gap-2'>
                  <div className='min-w-0 space-y-1'>
                    <p className='truncate text-sm font-semibold text-neutral-900'>
                      {item.name}
                    </p>
                    <p className='text-xs text-neutral-500'>
                      {item.color} / {item.size}
                    </p>
                  </div>
                  <button
                    type='button'
                    aria-label={removeAriaLabel}
                    onClick={() => onRemove(item)}
                    className='flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700'
                  >
                    <X size={16} />
                  </button>
                </div>
                <p className='text-sm font-bold text-neutral-900'>
                  {formatPrice(item.price)}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  )
}
